import { MenuConfigResponse, SettingsConfigResponse } from '../base-api';
import { ErweiterungConfigResponse } from '../base-api/model/erweiterungConfigResponse';
import { ParameterConfigResponse } from '../base-api/model/parameterConfigResponse';
import { Observable } from 'rxjs';
import { AppPrintConfig } from './app-print-config';
import { AppFormatConfig } from './app-format-config';
import { AppImageConfig } from './app-image-config';

export abstract class FormatConfigService {

  abstract init(): Promise<any>;

  abstract get menuConfig$(): Observable<MenuConfigResponse>;

  abstract get imageConfig$(): Observable<AppImageConfig>;

  abstract get initialized$(): Observable<boolean> ;

  abstract get settingsConfig$(): Observable<SettingsConfigResponse>;

  abstract get erweiterungsConfig$(): Observable<ErweiterungConfigResponse>;

  abstract get parameterConfig$(): Observable<ParameterConfigResponse>;

  abstract get printConfig$(): Observable<AppPrintConfig>;

  abstract get formatConfig$(): Observable<AppFormatConfig>;

}
